///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { NgModule } from '@angular/core';
import { GtthTextEscape } from './pipes/pipe.gtthTextEscape';
import { SecondsToTime } from './pipes/pipe.secondsToTime';
import { SafeHtml } from './pipes/pipe.SafeHtml';

@NgModule({
    declarations: [GtthTextEscape, SecondsToTime, SafeHtml],
    exports: [GtthTextEscape, SecondsToTime, SafeHtml]
})
export class GtthSharePipesModule {}
